import { Info } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const PageNotFound = () => {
    const navigate =useNavigate()
    const BackToHome = () =>{
        navigate('/')
    }
        
  return (
    <div className='flex h-[88dvh] items-center justify-center'>
        <div className="text-center">
           
            <h1 className='theme-color text-[150px] font-bold leading-[124px]'>
                404
            </h1>
            <p className='font-bold text-[50px] mb-4'>
            Oops! Page not found!
            </p> 
            <span className='flex items-center justify-center mb-7 '>
                <span className='mr-2'>
            <Info width={30}/>
                </span>
            <p className='font-semibold '>
            The page you requested was not found. 
            </p>
            </span>
            
            <button onClick={BackToHome} className='theme-button px-3 py-4 font-bold rounded-2xl'>Redirect To Home Page</button>
        </div>
    </div>
  )
}

export default PageNotFound